import { EMAIL_DETAILS_FORM_FIELDS_MAP } from 'features/sendouts/components/forms/EmailDetails/EmailDetails.fields';

import {
  buildAttachmentReferences,
  buildEmailList,
  buildNumberValue,
  mapCancelEmailToSendEmail
} from './SendoutForm.utils';

export const SENDOUT_TEMPLATE_ID = 3;

export const FORM_FIELDS_MAP = {
  ...EMAIL_DETAILS_FORM_FIELDS_MAP,
  CandidateRecruiter: {
    key: 'candidateRecruiter'
  },
  EstimatedFeeAmount: {
    key: 'estimatedFeeAmount'
  },
  InterviewType: {
    key: 'interviewType'
  },
  InterviewDate: {
    key: 'interviewDate'
  },
  InterviewTimeFrame: {
    key: 'interviewTimeFrame'
  },
  InterviewFromHour: {
    key: 'interviewFromHour'
  },
  InterviewToHour: {
    key: 'interviewToHour'
  },
  InterviewAddress: {
    key: 'interviewAddress'
  },
  InterviewLink: {
    key: 'interviewLink'
  },
  InterviewTimezone: {
    key: 'interviewTimezone'
  },
  DontSendReminders: {
    key: 'dontSendReminders'
  },
  Attachments: {
    key: 'attachments'
  },
  EmailBody: EMAIL_DETAILS_FORM_FIELDS_MAP.EmailBody,
  ResolvedEmailBody: EMAIL_DETAILS_FORM_FIELDS_MAP.ResolvedEmailBody
};

export const SENDOUT_CREATION_FIELDS_MAP = {
  AccountableRecruiter: {
    key: FORM_FIELDS_MAP.AccountableRecruiter.key,
    paramKey: 'jobOrderAccountableId',
    outboundAccesor: 'id'
  },
  CandidateRecruiter: {
    key: FORM_FIELDS_MAP.CandidateRecruiter.key,
    paramKey: 'candidateAccountableId',
    outboundAccesor: 'id'
  },
  Candidate: {
    key: FORM_FIELDS_MAP.Candidate.key,
    paramKey: 'candidateId',
    outboundAccesor: 'id'
  },
  HiringAuthority: {
    key: FORM_FIELDS_MAP.HiringAuthority.key,
    paramKey: 'hiringAuthorityId',
    outboundAccesor: 'id'
  },
  EstimatedFeeAmount: {
    key: FORM_FIELDS_MAP.EstimatedFeeAmount.key,
    paramKey: 'feeAmount',
    outboundAccesor: buildNumberValue
  },
  CancelEmailToHiringAuthority: {
    key: FORM_FIELDS_MAP.CancelEmailToHiringAuthority.key,
    paramKey: 'sendEmailToHiringAuthority',
    outboundAccesor: mapCancelEmailToSendEmail
  },
  Attachments: {
    key: FORM_FIELDS_MAP.Attachments.key,
    paramKey: 'attachments',
    outboundAccesor: buildAttachmentReferences
  }
};

export const SENDOUT_CREATION_EMAIL_FIELDS_MAP = {
  CarbonCopy: {
    key: FORM_FIELDS_MAP.CarbonCopy.key,
    paramKey: 'ccEmails',
    outboundAccesor: buildEmailList
  },
  BlindCarbonCopy: {
    key: FORM_FIELDS_MAP.BlindCarbonCopy.key,
    paramKey: 'bccEmails',
    outboundAccesor: buildEmailList
  },
  EmailSubject: {
    key: FORM_FIELDS_MAP.EmailSubject.key,
    paramKey: 'subject'
  },
  EmailBody: {
    key: FORM_FIELDS_MAP.EmailBody.key,
    paramKey: 'body'
  }
};

export const CONFIRMATION_DIALOGS = {
  NoAttachments: 'noAttachments',
  Preview: 'preview',
  WithoutMailConfirmation: 'withoutMailConfirmation',
  CloseForm: 'closeForm'
};
